module.exports = __webpack_public_path__ + "img/risk-tip.9dbbaf0d.png";